
export default function TestimonialsSection() {
  const testimonials = [
    {
      name: 'Carlos Eduardo Silva',
      position: 'Gerente de Operações',
      company: 'Metalúrgica Industrial',
      content: 'Regiane transformou nosso processo produtivo. Com o planejamento dela, aumentamos nossa eficiência em 25% e reduzimos drasticamente os atrasos.',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=Professional%20middle-aged%20business%20manager%20in%20industrial%20setting%2C%20confident%20smile%2C%20wearing%20business%20attire%2C%20industrial%20background%20with%20modern%20equipment%2C%20professional%20headshot%20style%2C%20clean%20lighting%2C%20testimonial%20photo%20style&width=80&height=80&seq=testimonial-1&orientation=squarish'
    },
    {
      name: 'Marina Santos',
      position: 'Diretora de Engenharia',
      company: 'Construtora Horizonte',
      content: 'Profissional excepcional! Seu trabalho na compatibilização BIM nos salvou tempo e recursos. Recomendo sem hesitação para projetos complexos.',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=Professional%20female%20engineer%20director%20in%20construction%20environment%2C%20confident%20posture%2C%20wearing%20safety%20helmet%20and%20professional%20attire%2C%20construction%20site%20background%2C%20professional%20headshot%20style%2C%20natural%20lighting&width=80&height=80&seq=testimonial-2&orientation=squarish'
    },
    {
      name: 'Roberto Fernandes',
      position: 'Coordenador de Segurança',
      company: 'Indústria Química ABC',
      content: 'A análise de riscos feita pela Regiane foi fundamental para nossa certificação. Abordagem técnica impecável e total conformidade regulatória.',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=Professional%20safety%20coordinator%20in%20industrial%20chemical%20plant%2C%20wearing%20safety%20equipment%2C%20serious%20professional%20expression%2C%20chemical%20industry%20background%2C%20safety-focused%20environment%2C%20professional%20headshot%20style&width=80&height=80&seq=testimonial-3&orientation=squarish'
    }
  ];

  const cases = [
    {
      title: 'Redução de 30% no Tempo de Setup',
      problem: 'Empresa metalúrgica com tempos de setup excessivos impactando produtividade',
      solution: 'Implementação de metodologia SMED e rebalanceamento das operações',
      result: 'Redução de 30% no tempo de setup e aumento de 18% na produtividade geral',
      industry: 'Metalúrgica',
      icon: 'ri-time-line'
    },
    {
      title: 'Projeto BIM Zero Incompatibilidades',
      problem: 'Construtora com retrabalhos constantes por falta de compatibilização',
      solution: 'Implementação de processo de compatibilização BIM/Revit integrado',
      result: 'Zero incompatibilidades em projeto de R$ 15 milhões, economia de 45 dias',
      industry: 'Construção Civil',
      icon: 'ri-building-line'
    },
    {
      title: 'Certificação de Segurança Aprovada',
      problem: 'Indústria química com não-conformidades em auditoria de segurança',
      solution: 'Análise completa de riscos e implementação de POPs específicos',
      result: 'Certificação aprovada sem ressalvas e redução de 60% em incidentes',
      industry: 'Química',
      icon: 'ri-shield-check-line'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Testimonials */}
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold mb-6 text-gray-900">
            O que Dizem Meus <span className="text-yellow-600">Clientes</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Feedback real de empresas que transformaram seus resultados com meus serviços.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-20">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-gray-50 rounded-2xl p-8 relative">
              <div className="flex items-center mb-6">
                <img 
                  src={testimonial.image}
                  alt={testimonial.name}
                  className="w-16 h-16 rounded-full object-cover object-top mr-4"
                />
                <div>
                  <h4 className="font-bold text-gray-900">{testimonial.name}</h4>
                  <p className="text-yellow-600 font-medium text-sm">{testimonial.position}</p>
                  <p className="text-gray-600 text-sm">{testimonial.company}</p>
                </div>
              </div>
              
              <div className="flex mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-500"></i>
                ))}
              </div>
              
              <p className="text-gray-700 leading-relaxed italic">"{testimonial.content}"</p>
              
              <i className="ri-double-quotes-r text-4xl text-yellow-200 absolute top-4 right-6"></i>
            </div>
          ))}
        </div>

        {/* Cases */}
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold mb-6 text-gray-900">
            Cases de <span className="text-yellow-600">Sucesso</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Resultados concretos alcançados em projetos reais.
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-8">
          {cases.map((caseItem, index) => (
            <div key={index} className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow">
              <div className="flex items-center justify-between mb-6">
                <div className="w-12 h-12 bg-yellow-100 rounded-lg flex items-center justify-center">
                  <i className={`${caseItem.icon} text-xl text-yellow-600`}></i>
                </div>
                <span className="bg-yellow-100 text-yellow-800 px-3 py-1 rounded-full text-sm font-medium">
                  {caseItem.industry}
                </span>
              </div>
              
              <h3 className="text-xl font-bold text-gray-900 mb-6">{caseItem.title}</h3>
              
              <div className="space-y-4">
                <div>
                  <h4 className="font-semibold text-red-600 mb-2 flex items-center">
                    <i className="ri-error-warning-line mr-2"></i>
                    Problema
                  </h4>
                  <p className="text-gray-700 text-sm leading-relaxed">{caseItem.problem}</p>
                </div>
                
                <div>
                  <h4 className="font-semibold text-blue-600 mb-2 flex items-center">
                    <i className="ri-lightbulb-line mr-2"></i>
                    Solução
                  </h4>
                  <p className="text-gray-700 text-sm leading-relaxed">{caseItem.solution}</p>
                </div>
                
                <div>
                  <h4 className="font-semibold text-green-600 mb-2 flex items-center">
                    <i className="ri-trophy-line mr-2"></i>
                    Resultado
                  </h4>
                  <p className="text-gray-700 text-sm leading-relaxed font-medium">{caseItem.result}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
